import React from 'react';
import CardBuySuccess from 'components/atoms/card_buy_success';

const CardSuccess: React.FC = () => {
  return (
    <div className="page-container">
      <CardBuySuccess />
    </div>
  );
};
export { CardSuccess };
